export const path = "https://oa.haosen.com.cn:8644/api/"
export const imgpath = "https://oa.haosen.com.cn:8644/"